export default function toQueryString(object) { return new URLSearchParams(object).toString(); }
